import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import { RouteSeo } from "@/components/Seo";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";

const Services = lazy(() => import("@/pages/Services"));
const ServiceDetail = lazy(() => import("@/pages/ServiceDetail"));
const Problems = lazy(() => import("@/pages/Problems"));
const ProblemDetail = lazy(() => import("@/pages/ProblemDetail"));
const Methodology = lazy(() => import("@/pages/Methodology"));
const Industries = lazy(() => import("@/pages/Industries"));
const IndustryDetail = lazy(() => import("@/pages/IndustryDetail"));
const Resources = lazy(() => import("@/pages/Resources"));
const Insights = lazy(() => import("@/pages/Insights"));
const ArticleDetail = lazy(() => import("@/pages/ArticleDetail"));
const CaseStudies = lazy(() => import("@/pages/CaseStudies"));
const CaseStudyDetail = lazy(() => import("@/pages/CaseStudyDetail"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const Webinars = lazy(() => import("@/pages/Webinars"));
const AssessmentLanding = lazy(() => import("@/pages/AssessmentLanding"));
const TechnologyHealthSnapshot = lazy(() => import("@/pages/TechnologyHealthSnapshot"));
const BusinessITSupport = lazy(() => import("@/pages/BusinessITSupport"));
const ITSupportPlan = lazy(() => import("@/pages/ITSupportPlan"));
const SwitchITProvider = lazy(() => import("@/pages/SwitchITProvider"));
const SnapshotThankYou = lazy(() => import("@/pages/SnapshotThankYou"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const PortalLogin = lazy(() => import("@/pages/PortalLogin"));
const PortalDashboard = lazy(() => import("@/pages/PortalDashboard"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteSeo />
        <Suspense fallback={null}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/problems" element={<Problems />} />
              <Route path="/problems/:slug" element={<ProblemDetail />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/industries/:slug" element={<IndustryDetail />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<ArticleDetail />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/webinars" element={<Webinars />} />
              <Route path="/assessments/:slug" element={<AssessmentLanding />} />
              <Route path="/business-it-support" element={<BusinessITSupport />} />
              <Route path="/it-support/:plan" element={<ITSupportPlan />} />
              <Route path="/switch-it-provider" element={<SwitchITProvider />} />
              <Route path="/technology-health-snapshot" element={<TechnologyHealthSnapshot />} />
              <Route path="/technology-health-snapshot/thank-you" element={<SnapshotThankYou />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<LegalPage title="Privacy Policy" kind="privacy" />} />
              <Route path="/terms" element={<LegalPage title="Terms of Use" kind="terms" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route element={<AuthProvider><Outlet /></AuthProvider>}>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/portal/login" element={<PortalLogin />} />
              <Route path="/portal" element={<PortalDashboard />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
